import { Link } from 'react-router-dom'
import { useTheme } from '../../context/ThemeContext'
import { useCart } from '../../context/CartContext'
import SearchBar from '../search/SearchBar'
import AnimatedGlobe from '../logo/AnimatedGlobe'
import './Header.css'

export default function Header() {
    const { theme, toggleTheme } = useTheme()
    const { cartCount } = useCart()

    return (
        <header className="header">
            <div className="header-container container">
                {/* Logo */}
                <Link to="/" className="logo">
                    <AnimatedGlobe />
                    <span className="logo-text">SecondWorld</span>
                </Link>

                {/* Search Bar */}
                <div className="header-search">
                    <SearchBar />
                </div>

                {/* Navigation */}
                <nav className="nav hide-mobile">
                    <Link to="/" className="nav-link">Home</Link>
                    <Link to="/products" className="nav-link">Products</Link>
                    <Link to="/about" className="nav-link">About</Link>
                    <Link to="/contact" className="nav-link">Contact</Link>
                </nav>

                {/* Actions */}
                <div className="header-actions">
                    {/* Theme Toggle */}
                    <button
                        className="icon-btn"
                        onClick={toggleTheme}
                        aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
                    >
                        {theme === 'light' ? '🌙' : '☀️'}
                    </button>

                    {/* Cart */}
                    <Link to="/cart" className="cart-btn">
                        <span className="cart-icon">🛒</span>
                        {cartCount > 0 && (
                            <span className="cart-badge">{cartCount}</span>
                        )}
                    </Link>

                    {/* Mobile Menu Toggle */}
                    <button className="icon-btn hide-desktop mobile-menu-btn">
                        ☰
                    </button>
                </div>
            </div>
        </header>
    )
}
